export default __webpack_public_path__ + "static/media/maypay_icon_x_blue.978f3b94.svg";